module.exports = __webpack_public_path__ + "static/media/profile-edit.41469dc9.svg";